import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch { /* keep polling */ }
      attempts.current += 1;
      if (attempts.current < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0d0914] flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="max-w-md w-full bg-[#140b22] border border-[#3b126d] rounded-2xl p-10 text-center shadow-xl">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
            <h1 className="f-poster text-3xl uppercase text-white mb-3" data-testid="payment-confirmed-title">Pago Confirmado</h1>
            <p className="text-sm text-[#d8b4fe] leading-relaxed mb-6">
              Tu pago se ha procesado correctamente. ELADRAOUI Abdelhamid se pondrá en marcha con tu encargo y te contactará directamente.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="w-14 h-14 text-[#e879f9] mx-auto mb-4 animate-spin" />
            <h1 className="f-poster text-3xl uppercase text-white mb-3" data-testid="payment-checking-title">Verificando Pago</h1>
            <p className="text-sm text-[#d8b4fe] leading-relaxed mb-6">
              Estamos confirmando tu pago con el procesador seguro. No cierres esta ventana.
            </p>
          </>
        )}
        <Link to="/" className="f-poster uppercase text-xs tracking-wide border border-[#581c87] text-white px-6 py-3 rounded hover:border-[#e879f9] transition-colors inline-block" data-testid="payment-home-link">
          Volver a ELADPENTESTER
        </Link>
      </div>
    </div>
  );
}
